import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";

export class WonTitleAssetRequestParams extends AssetsRequestParams {
  constructor(width: Number,height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + '/won_title';
    this.c = null;
  }
}
